import React from 'react'
import { Link } from 'react-router-dom'
import bg3 from '../../assets/images/background/bg-3.png'
import badge1 from '../../assets/images/resource/badge-1.png'
import img1 from '../../assets/images/resource/image-1.jpg'
import img2 from '../../assets/images/resource/image-2.jpg'
import Pdf from  '../../../src/Menu.pdf'

function Story() {
    return (
        <>
            <section className="story-section">
                <div className="left-bg">
                    <img src={bg3} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="text-col col-xl-5 col-lg-5 col-md-12 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="title-box centered">
                                    <div className="subtitle">
                                        <span> Our story </span>
                                    </div>
                                    <div className="pattern-image">
                                        <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                    </div>
                                    <h2>Every Flavor Tells a Story</h2>
                                    <h2>Beef Nihari</h2>
                                    <div className="text">Slow-cooked perfection—this beef nihari is rich, tender, and deeply flavorful!, Every spoonful of this nihari tastes like hours of love and spice, Nihari so good, you’ll forget every other dish exists!</div>
                                    <div className="text">Malai Boti <br></br>So soft it melts in your mouth—this Malai Boti is next level!, Creamy, smoky, and packed with flavor—can’t get enough of this!, Malai Boti done right: juicy, tender, and full of buttery goodness</div>
                                </div>
                                <div className="booking-info">
                                    <div className="bk-title">Book Through Call</div>
                                    <div className="bk-no"><Link to="tel:+80-400-123456">+1 416 723 6674</Link></div>
                                    <div className="link-box">
                                    <Link to={Pdf} className="theme-btn btn-style-two clearfix" target="blank">
                                        <span className="btn-wrap">
                                            <span className="text-one">view all menu </span>
                                            <span className="text-two">view all menu</span>
                                        </span>
                                    </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="image-col col-xl-7 col-lg-7 col-md-12 col-sm-12">
                            <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="round-stamp"></div>
                                <div className="images parallax-scene-1">
                                    <div className="image" data-depth="0.15"><img src={img1} alt="" /></div>
                                    <div className="image" data-depth="0.30"><img src={img2} alt="" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Story